/**
 * ObjectFieldSetSideBar React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material-UI
import {withStyles} from "@material-ui/core";

// 3rd party
import _ from "lodash";

// application components
import ObjectField from "./ObjectField";
import ObjectFieldSupplement from "./ObjectFieldSupplement";
import MediaItemSideBar from "./MediaItemSideBar";
import PresentationProgramPreview from "../editextensions/PresentationProgramPreview";
import PresentationFolderPreview from "../editextensions/PresentationFolderPreview";
import PresentationFilePreview from "../editextensions/PresentationFilePreview";
import PresentationChapterPreview from '../editextensions/PresentationChapterPreview';


// define components for different object types
const objectSideBarComponents = {
    mediaitem: MediaItemSideBar,
    presentationprogram: PresentationProgramPreview,
    presentationfolder: PresentationFolderPreview,
    presentationfile: PresentationFilePreview,
    presentationtextchapter: PresentationChapterPreview,
    presentationimagechapter: PresentationChapterPreview,
    presentationvideochapter: PresentationChapterPreview,
    presentationinterviewchapter: PresentationChapterPreview
};


/**
 * ObjectFieldSetSideBar is container for object fields plus side bar
 *
 * @author Jens Gruschel
 */
export class ObjectFieldSetSideBar extends React.Component {

    render() {

        const objectFields = this.props.object.fields || {};

        const sideBarFields = this.props.sideBarFieldSets ? _.flatMap(this.props.sideBarFieldSets, fieldSet => fieldSet.fields) : [];

        return <div className={this.props.classes.sideBar}>

            {this.renderObjectSideBarComponent()}

            {this.props.fieldSet.fields.map(
                fieldDef => <ObjectFieldSupplement
                    objectId={this.props.objectId}
                    key={fieldDef.id}
                    fieldDef={fieldDef}
                    value={objectFields[fieldDef.id]}
                    suffix={objectFields[fieldDef.id + "__suffix"]}
                    readOnly={this.props.readOnly}
                    onObjectValueChange={this.props.onObjectValueChange}
                />
            )}

            {sideBarFields.length > 0 && <div width={300}>
                {sideBarFields.map(
                    fieldDef => <ObjectField
                        objectId={this.props.objectId}
                        key={fieldDef.id}
                        fieldDef={fieldDef}
                        scope={this.props.scope}
                        value={objectFields[fieldDef.id]}
                        suffix={objectFields[fieldDef.id + "__suffix"]}
                        readOnly={this.props.readOnly && !fieldDef.transient}
                        onObjectValueChange={this.props.onObjectValueChange}
                    />
                )}
            </div>}
        </div>;
    }

    renderObjectSideBarComponent() {

        const SideBarElement = objectSideBarComponents[this.props.objectType];
        if (!SideBarElement) return null;

        const objectProps = {
            place: "sidebar",
            fieldSet: this.props.fieldSet,
            objectType: this.props.objectType,
            objectId: this.props.objectId,
            object: this.props.object,
            readOnly: this.props.readOnly,
            onObjectValueChange: this.props.onObjectValueChange
        };

        return <SideBarElement {...objectProps}/>;
    }
}

const styles = theme => ({
    sideBar: {
        "& > *": {
            position: "relative",
            marginLeft: 40,
            marginTop: 20,
            width: 300,
            overflow: "hidden"
        }        
    }
});

ObjectFieldSetSideBar.propTypes = {
    fieldSet: PropTypes.object.isRequired,
    sideBarFieldSets: PropTypes.array,
    objectType: PropTypes.string,
    objectId: PropTypes.string,
    object: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
    scope: PropTypes.arrayOf(PropTypes.string),
    onObjectValueChange: PropTypes.func.isRequired
};

export default withStyles(styles)(ObjectFieldSetSideBar);